import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Layout from "components/Layout";
import Home from "views/Home";
import Ecosystem from "views/Ecosystem";

import "./assets/style/index.css";
import "./assets/style/font.css";
import "swiper/css";
import "swiper/css/pagination";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
